import React from 'react'
import PropTypes from 'prop-types'

export default function Legend({ children, required, ...rest }) {
	return (
		<legend className="c-form__legend" {...rest}>
			{children}
			{required && <abbr className="c-form__required">*</abbr>}
		</legend>
	)
}

Legend.propTypes = {
	children: PropTypes.node,
	required: PropTypes.bool
}
Legend.defaultProps = {
	children: null,
	required: false
}
